/**
 * Reads one system default template out of the `GET /accounts/default-text`
 * payload.
 *
 * The payload is nested the same way the account's own templates are:
 *
 *   { emailConfiguration: { surveyInvitation: [{ language, text }, ...] },
 *     smsConfiguration:   { surveyReminder:   [...] } }
 *
 * One array per slot holds both languages, so a row reads it twice —
 * once per language — through its `configKey` / `topicKey` from
 * CUSTOM_EMAIL_SECTION_FIELDS. `language` (not `local`) is the key on
 * this endpoint; that is a legacy server quirk, not a typo.
 */
export const findDefaultTemplateText = (defaultTexts, row, language) => {
  const entries = defaultTexts?.[row?.configKey]?.[row?.topicKey];
  if (!Array.isArray(entries)) return '';
  return entries.find(entry => entry?.language === language)?.text || '';
};
